import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import Swal from 'sweetalert2';
import { getSwal } from '../../../../../utils/swalObject';
import { TipoRespostaService } from '../../../../../service/configuracao/tipo-resposta.service';

@Component({
  selector: 'app-incluir-tipo-resposta',
  templateUrl: './incluir-tipo-resposta.component.html',
  styleUrls: ['./incluir-tipo-resposta.component.scss']
})
export class IncluirTipoRespostaComponent implements OnInit {
  @ViewChild('codigo', {static: false}) codigo: ElementRef;

      incluirTipoRespostaForm: FormGroup;
      isDescricaoValida: any;

      constructor(
          private formBuilder: FormBuilder,
          private router: Router,
          private tipoRespostaService: TipoRespostaService
      ) {}

      ngOnInit() {
          this.criarFormulario();
      }

      criarFormulario(){
          this.incluirTipoRespostaForm = this.formBuilder.group({
              codigo: ['', [Validators.minLength(1),Validators.required]],
              descricao: ['', [Validators.minLength(5), Validators.maxLength(60), Validators.required]]
          })
          this.incluirTipoRespostaForm.get('descricao').valueChanges.subscribe(value => {
              this.isDescricaoValida = value.trim() !== '';
            });
      }

      consultarCodigo(codigo) {
          if(codigo == null){
              this.codigo.nativeElement.focus();
          }else{
              this.tipoRespostaService.consultaCodigo(codigo)
              .subscribe(
                  res => {
                      if(res) {
                          Swal.fire(
                              getSwal(
                                  'warning',
                                  'Código já em uso! Favor tentar outro valor.',
                                  '',
                                  'ok',
                                  null
                              )
                          ).then(() => {
                              this.incluirTipoRespostaForm.reset();
                              this.codigo.nativeElement.focus();
                          })
                      }
                  }
              )
          }
      }

      incluir() {
          const obj = this.incluirTipoRespostaForm.getRawValue();
          this.tipoRespostaService.incluirTipoResposta(obj)
              .subscribe(res => {
                  Swal.fire(
                      getSwal(
                          'success',
                          'Tipo de Resposta criada com sucesso',
                          '',
                          'ok',
                          null
                      )
                  ).then(() => this.router.navigate(['configuracao/tipo-resposta/consultar']));
              },
              err => {
                  Swal.fire(
                      getSwal(
                          'error',
                          'Ops!',
                          err.error.excecao.recomendacao,
                          'ok',
                          null
                      )
                  )
              }
          )
      }

      retornar() {
          this.router.navigate(['configuracao/tipo-resposta/consultar'])
      }
  }
